import './Menus.scss';

import { Column, Columns } from 'Components/Elements/Layouts';
import classNames from 'classnames';
import { TransFn, selectTranslator } from 'core/redux/features/languages/trans';
import {
  selectActiveProduct,
  selectIsUnderServing,
} from 'core/redux/features/products/reducers/products';
import {
  IProduct,
  IProductInfo,
  IProductInfoMenu,
  IProductMenu,
} from 'core/redux/features/products/types';
import { AppState } from 'core/redux/reducers';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Optional } from 'utility-types';
import { selectActiveProductMenuInfo } from '../../../../core/redux/features/products/reducers/productInfos';
import MenuCourses from './MenuCourses';

// interface IState {
//   activeMenus: number[];
// }

interface IProps {
  activeKey?: number;
  info: IProductInfo;
  product: IProduct;
  menus: Record<string, IProductMenu>;
  menuInfo: Record<string, IProductInfoMenu>;
  local: string;
  trans: TransFn;
  isUnderService: boolean;
}

function menuTypeInLowerCase(menu: IProductMenu) {
  if (typeof menu.menu_type === 'string') {
    return menu.menu_type.toLowerCase();
  }

  return '';
}

function MenuObs({
  value,
  withLine = false,
}: {
  value: string;
  withLine?: boolean;
}) {
  const cleanVal = value ? value.trim() : null;
  if (!cleanVal || cleanVal === '') {
    return null;
  }

  return (
    <>
      <p className="info-view-menu__obs">{cleanVal}</p>
      {withLine ? <hr /> : null}
    </>
  );
}

// export class MenusComponent extends Component<IProps, IState> {
//   constructor(props) {
//     super(props);
//
//     const { product } = this.props;
//     const menus = product?.menus;
//     const activeKey =
//       this.props.activeKey || (menus && menus.length > 1) ? -1 : 0;
//     this.state = {
//       activeMenus: [activeKey],
//     };
//   }
//
//   componentDidUpdate(
//     prevProps: Readonly<IProps>,
//     prevState: Readonly<IState>,
//     snapshot?: any,
//   ): void {
//     const { product } = this.props;
//     if (product !== prevProps.product) {
//       const activeMenus = product.menus.length === 1 ? [0] : [];
//       this.setState({ activeMenus });
//     }
//   }
//
//   componentDidMount(): void {
//     const { product } = this.props;
//     const menus = product?.menus;
//     if (menus && menus.length === 1) {
//       this.setState({ activeMenus: [0] });
//     }
//   }
//
//   onToggleMenu = (e: React.MouseEvent, key: number) => {
//     e.preventDefault();
//     if (this.state.activeMenus.indexOf(key) === -1) {
//       this.setState({
//         activeMenus: [...this.state.activeMenus, key],
//       });
//     } else {
//       this.setState({
//         activeMenus: this.state.activeMenus.filter(v => v !== key),
//       });
//     }
//   };
//
//   hasUnderServingTag = () => {};
//
//   render() {
//     const {
//       props: { product, menus, menuInfo, local, isUnderService },
//       state: { activeMenus },
//     } = this;
//
//     let menuSpecialObs = null;
//     if (isUnderService) {
//       menuSpecialObs = this.props.trans('underserving_tag');
//     }
//     console.log(1234);
//     return (
//       <div className="content info-view-menu">
//         {product &&
//           product.menus
//             .filter((id, i) => product.menus.indexOf(id) === i)
//             .map(menuId => {
//               const menuData = _get(menuInfo, menuId);
//               return {
//                 ...menus[menuId],
//                 ...menuData,
//                 menuId: menuId,
//               };
//             })
//             .sort((a, b) => {
//               const aSale = a.price_regular;
//               const bSale = b.price_regular;
//               return aSale === bSale ? 0 : aSale > bSale ? 1 : -1;
//             })
//             .sort((a, b) => {
//               // a less than b
//               if (a.menu_type === 'LUNCH' && b.menu_type !== 'LUNCH') {
//                 return 1;
//               }
//
//               // a greater than b
//               if (a.menu_type !== 'LUNCH' && b.menu_type === 'LUNCH') {
//                 return -1;
//               }
//
//               return 0;
//             })
//             .map((menu, key) => {
//               const menuId = menu.menuId;
//               const menuData = menu;
//               const isActive = activeMenus.indexOf(key) > -1;
//
//               const menuType = menuTypeInLowerCase(menu);
//               let menuTypeText: string = null;
//               if (['lunch'].indexOf(menuType) > -1) {
//                 menuTypeText = this.props.trans(`menu_type_text.${menuType}`);
//               }
//
//               return (
//                 <div key={menuId} className="info-view-menu__item">
//                   <div className="box">
//                     <div
//                       className="is-cursor-pointer"
//                       onClick={e => this.onToggleMenu(e, key)}
//                     >
//                       <Columns
//                         mobile={true}
//                         gap={1}
//                         className="info-view-menu__top"
//                       >
//                         <Column className="info">
//                           <h2 className="no-mr">
//                             {local === 'en' && menu.restaurant_menu_name_en
//                               ? menu.restaurant_menu_name_en
//                               : menu.name}
//                           </h2>
//                         </Column>
//                         <Column>
//                           <div className="price">
//                             <span className="tag is-white is-multiline is-normal">
//                               {menu.price_regular} <small>kr</small>
//                             </span>
//                             <span className="tag is-sale is-multiline">
//                               {menu.price_sale} <small>KR</small>
//                             </span>
//                           </div>
//                         </Column>
//                       </Columns>
//                     </div>
//
//                     <div
//                       className={classNames('content', isActive && 'is-active')}
//                     >
//                       <button
//                         onClick={e => this.onToggleMenu(e, key)}
//                         className="button is-circle has-icon"
//                       >
//                         <span
//                           className={classNames(
//                             'eb',
//                             activeMenus.indexOf(key) > -1 ? 'eb-ru' : 'eb-rd',
//                           )}
//                         />
//                       </button>
//                       <div className="info-view-menu__content">
//                         <MenuObs value={menuTypeText} />
//                         <MenuObs value={menuSpecialObs} />
//                         <MenuObs value={menuData?.obs} withLine={true} />
//
//                         {menuData && <MenuCourses menuId={menuData.id} />}
//                         {menuData && (
//                           <p
//                             className="info-view-menu__bottom"
//                             dangerouslySetInnerHTML={{
//                               __html: menuData
//                                 ? menuData.bottom_content?.replace(/\s+$/g, '')
//                                 : '',
//                             }}
//                           />
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//       </div>
//     );
//   }
// }

const mapStateToProps = (state: AppState) => {
  return {
    local: state.local,
    product: selectActiveProduct(state),
    // info: selectActiveProductInfo(state),
    isUnderService: selectIsUnderServing(state),
    // menus: state.products.entities.menus,
    // menuInfo: selectActiveProductMenuInfo(state),
    trans: selectTranslator(state),
  };
};

export default function MenuComponentV2(_props: Optional<IProps>) {
  const {
    local,
    product,
    // info,
    isUnderService,
    // menus,
    trans,
  } = useSelector(mapStateToProps);

  const restoMenus = useSelector(selectActiveProductMenuInfo);

  const [activeMenus, setActiveMenus] = useState([]);
  useEffect(() => {
    setActiveMenus(product.menus.length === 1 ? [0] : []);
  }, [product.menus.length]);

  const onToggleMenu = (_e, key) => {
    if (activeMenus.indexOf(key) === -1) {
      setActiveMenus([...activeMenus, key]);
    } else {
      setActiveMenus(activeMenus.filter(v => v !== key));
    }
  };

  const [menuSpecialObs, setMenuSpecialObs] = useState<string | null>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (isUnderService) {
      setMenuSpecialObs(trans('underserving_tag'));
    } else {
      setMenuSpecialObs(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUnderService]);

  return (
    <div className="content info-view-menu">
      {restoMenus.map((menu, key) => {
        const isEntireTable = menu.all_table_size > 0;
        const menuId = menu.id;
        const isActive = activeMenus.indexOf(key) > -1;

        const menuType = menuTypeInLowerCase(menu);
        let menuTypeText: string = null;
        if (['lunch'].indexOf(menuType) > -1) {
          menuTypeText = trans(`menu_type_text.${menuType}`);
        }

        let entireTableText: string | null = null;
        if (isEntireTable) {
          entireTableText = trans('menu_select_entire_table');
        }

        return (
          <div key={menuId} className="info-view-menu__item">
            <div className="box">
              <div
                className="is-cursor-pointer"
                onClick={e => onToggleMenu(e, key)}
              >
                <Columns mobile={true} gap={1} className="info-view-menu__top">
                  <Column className="info">
                    <h2 className="no-mr">
                      {local === 'en' && menu.restaurant_menu_name_en
                        ? menu.restaurant_menu_name_en
                        : menu.name}
                    </h2>
                  </Column>
                  <Column>
                    <div className="price">
                      <span className="tag is-white is-multiline is-normal">
                        {menu.price_regular} <small>kr</small>
                      </span>
                      <span className="tag is-sale is-multiline">
                        {menu.price_sale} <small>KR</small>
                      </span>
                    </div>
                  </Column>
                </Columns>
              </div>

              <div className={classNames('content', isActive && 'is-active')}>
                <button
                  onClick={e => onToggleMenu(e, key)}
                  className="button is-circle has-icon"
                >
                  <span
                    className={classNames(
                      'eb',
                      activeMenus.indexOf(key) > -1 ? 'eb-ru' : 'eb-rd',
                    )}
                  />
                </button>
                <div
                  className="info-view-menu__content"
                  style={{ whiteSpace: 'pre-wrap' }}
                >
                  <MenuObs value={menuTypeText} />
                  <MenuObs value={menuSpecialObs} />
                  <MenuObs value={entireTableText} />
                  <MenuObs value={menu.obs} withLine={true} />

                  <MenuCourses menuId={menu.id} />
                  {menu.bottom_content?.length > 0 && (
                    <p
                      className="info-view-menu__bottom"
                      dangerouslySetInnerHTML={{
                        __html: menu.bottom_content?.replace(/\s+$/g, ''),
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
